// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const StorageIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="StorageIcon" ref={forwardedRef} {...props}>
      <path d="M3 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm1.5 5.25h11V4.5h-11zm0 1.5v4.75h11v-4.75z" />
      <path d="M14 6.25h-1.5v1.5H14z" />
      <path d="M14 12.25h-1.5v1.5H14z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const StorageIcon = /* @__PURE__ */ Object.assign(StorageIconComponent, {
  displayName: 'StorageIcon',
});
